import Vue from 'vue';

window.I18n.locale = 'pl';
export default Vue.mixin({
  data() {
    return {
      get I18n() {
        return window.I18n;
      },
    };
  },
});



// WEBPACK FOOTER //
// ./app/javascript/packs/i18n.js